<template>
    <div class="weather-monitor">
        <!-- 标题 -->
        <div class="public-module-title" v-if="curDevice.typeName=='气象监测'&&curDevice.id!='867124065431348'">
            <img src="@/assets/images/publicTitle.png" alt="">
            <div>气象监测</div>
        </div>
        <div class="public-module-title" v-else>
            <img src="@/assets/images/publicTitle2.png" alt="">
            <div>空气质量监测</div>
        </div>

        <!-- 设备切换按钮 -->
        <div class="switch-btn">
            <el-carousel class="mycarousel" ref="mycarousel" height="30px" arrow="never" indicator-position="none" :autoplay="false">
                <el-carousel-item class="mycarousel-item" v-for="k in Math.ceil(list.length / 3)" :key="k">
                    <div class="btn-item" v-for="(item,i) in list.slice((k - 1) * 3, k * 3)" :key="i" :class="{active:curDevice.id == item.id}" @click="deviceChange(item)">
                        <span>{{item.name||'气象设备'+i+1}}</span>
                    </div>
                </el-carousel-item>
            </el-carousel>

            <div class="leftArrow" @click="prev">◀</div>
            <div class="rightArrow" @click="next">▶</div>
        </div>

        <!-- 气象因子 -->
        <div class="weather-factor" v-if="curDevice.typeName=='气象监测'&&curDevice.id!='867124065431348'" @mouseenter="enter" @mouseleave="leave">
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/wendu.webm"></video>
                 <img src="@/assets/images/dataMonitoring/wendu.png" alt="">
                 <div class="desc">
                    <div class="label">温度：</div>
                    <div class="value wdValue">{{realWeaData.term}}<span class="wdValue">℃</span></div>
                 </div>
            </div>
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/shidu.webm"></video>
                 <img src="@/assets/images/dataMonitoring/shidu.png" alt="">
                 <div class="desc">
                    <div class="label">湿度：</div>
                    <div class="value sdValue">{{realWeaData.hum}}<span class="sdValue">%RH</span></div>
                 </div>
            </div>
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/fengxiang.webm"></video>
                 <img src="@/assets/images/dataMonitoring/fengxiang.png" alt="">
                 <div class="desc">
                    <div class="label">风向：</div>
                    <div class="value fxValue">{{realWeaData.wdirStr}}</div>
                 </div>
            </div>
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/fengsu.webm"></video>
                 <img src="@/assets/images/dataMonitoring/fengsu.png" alt="">
                 <div class="desc">
                    <div class="label">风速：</div>
                    <div class="value fsValue">{{realWeaData.windSpeed}}<span class="fsValue">m/s</span></div>
                 </div>
            </div>
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/jyl.webm"></video>
                 <img src="@/assets/images/dataMonitoring/jyl.png" alt="">
                 <div class="desc">
                    <div class="label">降雨量：</div>
                    <div class="value jylValue">{{realWeaData.currentRainfall}}<span class="jylValue">mm</span></div>
                 </div>
            </div>
            <div class="factor-item">
                 <video autoplay muted loop src="@/assets/video/dataMonitoring/gzqd.webm"></video>
                 <img src="@/assets/images/dataMonitoring/gzqd.png" alt="">
                 <div class="desc">
                    <div class="label">光照强度：</div>
                    <div class="value gzqdValue">{{realWeaData.hv}}<span class="gzqdValue">lx</span></div>
                 </div>
            </div>
        </div>

        <!-- 空气质量监测 -->
        <div class="air-factor" v-else @mouseenter="enter" @mouseleave="leave">
            <div class="air-factor-item" v-for="(item,index) in realData" :key="index">
                <video autoplay muted loop :src="index%2==0?require('@/assets/video/dataMonitoring/ph.webm'):require('@/assets/video/dataMonitoring/ddl.webm')"></video>
                <div class="item-value">
                    <span class="trwdValue" :class="[index%2==0?'phValue':'ddlValue']">{{item.value}}</span>
                    <span class="unit">{{item.unit}}</span>
                </div>
                <div class="item-label">{{item.propertyName}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import {realData} from "@/api/lsyn2.js"
export default {
  name: '',
  props:{
    deviceList:{
        type:Array,
        default:''
    }
  },
  data () {
    return {
        index:0,
        list:[],
        deviceId:"",
        curDevice:{},
        realWeaData:{},
        realData:[]
    }
  },
  watch:{
        deviceList(newValue){
            console.log(newValue,"传递过来的气象设备")
            this.list=newValue
            this.curDevice=newValue[0]
            this.deviceId=newValue[0].id
            this.getRealData()
        }
    },
  created () {
  },
  mounted () {
    this.timer=setInterval(()=>{
        if(this.index>=this.deviceList.length-1){
            this.index=0
        }else{
            this.index++
        }

        if(this.$refs.mycarousel){
            this.$refs.mycarousel.setActiveItem(Math.ceil((this.index-2) / 3))
        }
        this.curDevice=this.deviceList[this.index]
        this.deviceId=this.curDevice.id
        this.getRealData()
    },5000)
  },
  
   destroyed(){
        clearInterval(this.timer)
    },

  methods: {
    // 设备切换
    deviceChange(val){
        this.curDevice=val
        this.deviceId=val.id
        this.index=this.deviceList.findIndex(val => val.id == this.deviceId)
        this.getRealData()
    },

    prev(){
        this.$refs.mycarousel.prev()
    },

    next(){
        this.$refs.mycarousel.next()
    },

    // 获取气象实时数据
    getRealData(){
        realData(this.deviceId).then(res=>{
            // console.log(res,"气象实时数据")
            this.realWeaData={}
            console.log("this.curDevice @@@ ",this.curDevice);
            
            if(res.code == 200){
                if(!res.data.length && this.deviceId == '869576053580808'){
                    this.realData=[
                            {
                                value:27.6,
                                unit:'℃',
                                propertyName:'空气温度',
                            },
                            {
                                value:64.3,
                                unit:'%',
                                propertyName:'空气湿度',
                            },
                            {
                                value:33719,
                                unit:'lux',
                                propertyName:'光照强度',
                            },
                            {
                                value:18.6,
                                unit:'%',
                                propertyName:'氨气',
                            },
                            {
                                value:0.13,
                                unit:'ppm',
                                propertyName:'硫化氢',
                            }
                        ]
                    return
                }
                if(!res.data.length && this.deviceId == '867124065428096'){
                    this.realData=[
                            {
                                value:16.6,
                                unit:'℃',
                                propertyName:'空气温度',
                            },
                            {
                                value:53.3,
                                unit:'%',
                                propertyName:'空气湿度',
                            },
                            {
                                value:8319,
                                unit:'lux',
                                propertyName:'光照强度',
                            },
                            {
                                value:18.6,
                                unit:'%',
                                propertyName:'氨气',
                            },
                            {
                                value:0.13,
                                unit:'ppm',
                                propertyName:'硫化氢',
                            }
                        ]
                    return
                }
                if(!res.data.length && this.deviceId == '867124065354003'){
                    this.realData=[
                            {
                                value:15.6,
                                unit:'℃',
                                propertyName:'空气温度',
                            },
                            {
                                value:54.3,
                                unit:'%',
                                propertyName:'空气湿度',
                            },
                            {
                                value:8719,
                                unit:'lux',
                                propertyName:'光照强度',
                            },
                            {
                                value:18.6,
                                unit:'%',
                                propertyName:'氨气',
                            },
                            {
                                value:0.13,
                                unit:'ppm',
                                propertyName:'硫化氢',
                            }
                        ]
                    return
                }

                if(this.curDevice.typeName=='气象监测'&&this.deviceId!='867124065431348'){
                    res.data.forEach(val => {
                        if(val.property == 'fdir'){
                            this.$set(this.realWeaData,'wdirStr',val.formatValue)
                        }else if(val.property == 'fdsp'){
                            this.$set(this.realWeaData,'windSpeed',val.numberValue)
                        }else if(val.property == 'hmdy'){
                            this.$set(this.realWeaData,'hum',val.numberValue)
                        }else if(val.property == 'lux'){
                            this.$set(this.realWeaData,'hv',val.numberValue)
                        }else if(val.property == 'rain20min'){
                            this.$set(this.realWeaData,'currentRainfall',val.numberValue)
                        }else if(val.property == 'tmp'){
                            this.$set(this.realWeaData,'term',val.numberValue)
                        }
                    })
                }else{
                     if(this.deviceId=='867124065431348'){ //家禽养殖设备
                        this.realData=[
                            {
                                value:27.6,
                                unit:'℃',
                                propertyName:'空气温度',
                            },
                            {
                                value:64.3,
                                unit:'%',
                                propertyName:'空气湿度',
                            },
                            {
                                value:33719,
                                unit:'lux',
                                propertyName:'光照强度',
                            },
                            {
                                value:18.6,
                                unit:'%',
                                propertyName:'氨气',
                            },
                            {
                                value:0.13,
                                unit:'ppm',
                                propertyName:'硫化氢',
                            }
                        ]
                    }else{
                        realData(this.deviceId).then(res=>{
                            this.realData=[]
                            if(res.code == 200){
                            this.realData=res.data
                            }
                        })
                    }
                }
            }
        })
    },

    // 鼠标移入
    enter(){
        clearInterval(this.timer)
    },

    // 鼠标移出
    leave(){
        this.timer=setInterval(()=>{
            if(this.index>=this.deviceList.length-1){
                this.index=0
            }else{
                this.index++
            }
            if(this.$refs.mycarousel){
                this.$refs.mycarousel.setActiveItem(Math.ceil((this.index-2) / 3))
            }
            this.curDevice=this.deviceList[this.index]
            this.deviceId=this.curDevice.id
            this.getRealData()
        },5000)
    }
    
  }
}
</script>
<style lang="less" scoped>
.weather-monitor{
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
    // .switch-btn{
    //     margin-top: 20px;
    //     padding: 0 20px;
    //     display: flex;
    //     justify-content: space-between;
    //     border-bottom: 1px solid  rgba(206, 234, 237, 0.3);
    //     .btn-item{
    //         padding: 6px 8px;
    //         background: url("~@/assets/images/dataMonitoring/btn_switch_bg.png");
    //         background-size: 100% 100%;
    //         display: flex;
    //         align-items: center;
    //         cursor: pointer;
    //         span{
    //             font-size: 14px;
    //             font-weight: 700;
    //             color: rgba(255, 255, 255, 0.8);
    //         }          
    //     }
    //     .active{
    //         background: url("~@/assets/images/dataMonitoring/btn_switch_active_bg.png");
    //         background-size: 100% 100%;
    //         span{
    //             font-weight: 700;
    //             color:transparent;
    //             background: linear-gradient(180deg,  rgba(255, 255, 255, 1) 0%, rgba(18, 224, 200, 1) 100%);
    //             -webkit-background-clip: text;
    //         }         
    //     }
    // }

    .weather-factor{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-top: 17px;
        .factor-item{
            position: relative;
            margin-right: 25px;
            margin-bottom: 23px;
            width: 122px;
            &:nth-child(1n){
                margin-left: -30px;
            }
            video{
                height: 100px;
            }
            >img{
                position: absolute;
                top: 15px;
                left: 73%;
                transform: translateX(-50%);
            }
            .desc{
                display: flex;
                align-items: center;
                position: absolute;
                bottom: 8px;
                left: 75%;
                transform: translateX(-50%);
                white-space: nowrap;
                .label{
                    font-size: 14px;
                    color: rgba(255, 255, 255, 1);
                }
                .value{
                    font-size: 18px;
                    font-weight: 700;
                    span{
                        font-size: 14px;
                    }
                    
                }
                .wdValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15.13%, rgba(24, 154, 206, 1) 100%);
                    -webkit-background-clip: text;
                }
                .sdValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1)  15.13%, rgba(206, 109, 24, 1) 100%);
                    -webkit-background-clip: text;
                }
                .fxValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15.13%, rgba(206, 200, 24, 1) 100%);
                    -webkit-background-clip: text;
                }
                .fsValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15.13%, rgba(24, 206, 197, 1) 100%);
                    -webkit-background-clip: text;
                }
                .jylValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15.13%, rgba(25, 131, 207, 1) 100%);
                    -webkit-background-clip: text;
                }
                .gzqdValue{
                    color:transparent;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15.13%, rgba(85, 206, 24, 1) 100%);
                    -webkit-background-clip: text;
                }
            }
        }
    }

    .air-factor{
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .air-factor-item{
            position: relative;
            width: 110px;
            margin-bottom: 10px;
            video{
                width: 110px;
                height: 80px;
            }
            .item-value{
                font-size: 20px;
                font-weight: 700;
                text-shadow: 0px 0px 8px rgba(51, 228, 255, 0.5);
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                flex-direction: column;
                align-items: center;

                .unit{
                    margin-left: 2px;
                    font-size: 12px;
                    font-weight: 500;
                    color: rgba(255, 255, 255, 0.8);
                    text-shadow: 0px 0px 8px rgba(51, 228, 255, 0.5);
                }
            }
            .item-label{
                margin-top: 4px;
                text-align: center;
                font-size: 16px;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.8);
                letter-spacing: 1px;     
            }

            .phValue{
                margin-top: 6px;
                color:transparent;
                background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(19, 242, 231, 1) 100%);
                -webkit-background-clip: text;
            }
            .ddlValue{
                color:transparent;
                background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(19, 179, 242, 1) 100%);
                -webkit-background-clip: text;
            }
        }
    }
}

</style>
